import type * as Actions from './actions';
import { ActionTypes } from './actionTypes';

import type { PastMaintenancesMaps } from '@cobliteam/api-lib';

export const loadPastMaintenancesRequest =
  (): Actions.LoadPastMaintenancesRequest => ({
    type: ActionTypes.LOAD_PAST_MAINTENANCES_REQUEST,
  });

export const loadPastMaintenancesSucceeded = (
  maps: PastMaintenancesMaps
): Actions.LoadPastMaintenancesSucceeded => ({
  type: ActionTypes.LOAD_PAST_MAINTENANCES_SUCCEEDED,
  payload: maps,
});

export const loadPastMaintenancesFailed =
  (): Actions.LoadPastMaintenancesFailed => ({
    type: ActionTypes.LOAD_PAST_MAINTENANCES_FAILED,
  });
